import './mainPageContainer.css';
import React, { useEffect, useState, FC } from 'react';
import { createWorker, createScheduler, PSM } from 'tesseract.js';
import { ImageListItemComponent } from '../../../core/components/imageList/ImageListComponent';

type PropsType = {
  imageUrl: string
  onChangeText: (value: string) => void;
};

const ImageRecognitionText: FC<PropsType> = ({ imageUrl, onChangeText }) => {
  const [load, setLoad] = useState(true);

  const scheduler = createScheduler();
  const worker1 = createWorker({
    logger: (m) => console.log(m)
  });
  const worker2 = createWorker({
    logger: (m) => console.log(m)
  });

  const doOCR = async () => {
    try {
      // await worker.load();
      // await worker.loadLanguage('rus');
      // await worker.initialize('rus');
      // const { data: { text } } = await worker.recognize(imageUrl);

      await worker1.load();
      await worker2.load();
      await worker1.loadLanguage('rus');
      await worker2.loadLanguage('rus');
      await worker1.initialize('rus');
      await worker2.initialize('rus');
      await worker1.setParameters({
        // @ts-ignore
        tessedit_pageseg_mode: PSM.AUTO_OSD,
      });
      await worker2.setParameters({
        // @ts-ignore
        tessedit_pageseg_mode: PSM.AUTO_OSD,
      });
      scheduler.addWorker(worker1);
      scheduler.addWorker(worker2);

      const { data: { text } } = await scheduler.addJob('recognize', imageUrl);

      onChangeText(text);
      setLoad(false);

      await scheduler.terminate();
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    imageUrl && doOCR();
  }, [imageUrl]);

  return (
        <ImageListItemComponent url={imageUrl} onClick={() => {}} load={load} />
  );
};

export default ImageRecognitionText;
